import "core-js";
import "@fullcalendar/react/dist/vdom";

import React from "react";
import { createRoot } from "react-dom/client";

import "@config/i18next";
import { initSentry } from "@config/sentry";
import { IS_DEV } from "@config/consts";
import { overrideBrowserTimezone } from "@config/overrideBrowserTimezone";

import { ORIGIN } from "@typings/globals";

import { checkAndInitHeadlessMode } from "@services/HeadlessMode";

import { App } from "./containers";

// rerender detector
if (IS_DEV && process.env.ENABLE_DETECT_RERENDER === "true") {
  require("../@services/DetectRerender/DetectRerender");
}

initSentry(ORIGIN.BATMAID);
checkAndInitHeadlessMode();
overrideBrowserTimezone();

const cleanup = () => {
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute("content", "#ffffff");
};

const container = document.getElementById("app");
const root = createRoot(container!);
root.render(<App />);

cleanup();
